export default "__VITE_ASSET__CD_cHcBz__"